<template>
  <div class="join">
    <div class="tabs-top">
      <div
        v-for="(item,index) of tabList"
        :key="'tab-'+index"
        class="item"
        @click="current=index"
        :class="{active:current==index}"
      >
        <span>{{item.name}}</span>
      </div>
    </div>
    <join-item :value="activeItem"></join-item>
  </div>
</template>

<script>
import joinItem from "./joinItem";

const joinListUri = "website/index/aj/get/all";

export default {
  data() {
    return {
      current: 0,
      tabList: [],
      activeItem: {}
    };
  },
  watch: {
    current(now) {
      this.activeItem = this.tabList[now];
    }
  },
  components: {
    joinItem
  },
  created() {
    this.getJoinList();
  },
  methods: {
    getJoinList() {
      this.$api.get(joinListUri).then(res => {
        this.tabList = res.list;
        this.activeItem = this.tabList[0] || {};
        console.log(this.activeItem);
      });
    }
  }
};
</script>
<style lang="less" scoped>
.join {
  width: 1200px;
  margin: 0 auto;
  box-shadow: 0px 4px 24px 0px rgba(238, 238, 238, 0.7);
  .tabs-top {
    display: flex;
    justify-content: space-around;
    overflow: hidden;
    background: #fff;
    border-bottom: 1px solid #eee;

    .item {
      cursor: pointer;
      white-space: nowrap;
      padding: 0 20px;

      span {
        display: inline-block;
        line-height: 68px;
        font-size: 18px;
        color: #333333;
        font-weight: 500;
      }
      &.active {
        border-bottom: 2px solid #e60616;
      }
    }
  }
}
</style>

